var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 3,
    fill: "#3381FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3639 14.1914H8.49805V16.8747H10.3639V14.1914ZM9.98656 16.4976H8.87554V14.5688H9.98656V16.4976Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7545 11.9492H10.8887V16.8756H12.7545V11.9492ZM12.3772 16.4985H11.2662V12.3264H12.3772V16.4985Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1432 15.0508H13.2773V16.8747H15.1432V15.0508ZM14.7662 16.4976H13.6552V15.4284H14.7662V16.4976Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5338 10.5H15.668V16.8729H17.5338V10.5ZM17.1563 16.4961H16.0453L16.0451 10.8776H17.1562L17.1563 16.4961Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.068 16.8728C17.8333 16.8728 17.6353 17.0216 17.5583 17.2293H8.1202V10.6601C8.32787 10.5831 8.47671 10.3851 8.47671 10.1505C8.47671 9.84946 8.2327 9.60547 7.93171 9.60547C7.63071 9.60547 7.38672 9.84948 7.38672 10.1505C7.38672 10.3848 7.53556 10.5832 7.74323 10.6601V17.6064H17.559C17.636 17.8141 17.8338 17.963 18.0686 17.963C18.3696 17.963 18.6136 17.7189 18.6136 17.418C18.6134 17.117 18.3689 16.873 18.0679 16.873L18.068 16.8728Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1638 7.51338H15.5291V6.67168C15.5291 6.29517 15.2668 6 14.9318 6H11.0689C10.7338 6 10.4715 6.29484 10.4715 6.67168V7.51351L4.83637 7.51334C4.37518 7.51334 4 7.88852 4 8.34972V19.2215C4 19.6827 4.37518 20.0578 4.83637 20.0578H21.1636C21.6248 20.0578 22 19.6827 22 19.2215V8.34972C22 7.88852 21.6248 7.51334 21.1636 7.51334L21.1638 7.51338ZM11.1898 6.71686H14.8124L14.8109 7.51321H11.1883L11.1898 6.71686ZM21.2833 19.2215C21.2833 19.2872 21.2295 19.341 21.1638 19.341L4.83655 19.3408C4.77055 19.3408 4.71705 19.287 4.71705 19.2213V8.34959C4.71705 8.28359 4.77055 8.23009 4.83655 8.23009H21.1638C21.2295 8.23009 21.2833 8.28359 21.2833 8.34959V19.2213V19.2215Z",
    fill: "white",
    stroke: "#3381FF",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.7564aa0bb69a6ab54dec048b774c03d5.svg";
export { ForwardRef as ReactComponent };